import { FC, SVGProps } from "react";

const Minus: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M28.3642 17H3.63623C3.08423 17 2.63623 16.552 2.63623 16C2.63623 15.448 3.08423 15 3.63623 15H28.3656C28.9176 15 29.3656 15.448 29.3656 16C29.3656 16.552 28.9176 17 28.3642 17Z"
        fill="white"
      />
    </svg>
  );
};

export default Minus;
